<div
  class="top-border-card"
  [style.borderColor]="borderColor()"
  [style.backgroundColor]="backgroundColor()">
  <div class="card-content">
    <ng-content />
  </div>
</div>
